import { Button, FormControl, InputLabel, Select, MenuItem, Grid } from "@material-ui/core"
import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import useApi from "../../../hooks/useAPI"
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { selectClienteTarget, cambiarFechaViajeAction } from "../../../ducks/clientesDuck"
import BackDrop from "../../../global/BackDrop"
import { formatDinero } from "../../../utils/formatDinero"
import { esFinalizado } from "../../../utils/esFinalizado"
const FFechaViaje = () => {
    const { cliente, referencia, verificado } = useSelector(store => store.cliente)
    const [value, setValue] = useState("0,0,0")
    const [fecha, setFecha] = useState("0")
    const [idBloque, setIdBloque] = useState("0")
    const [idObjeto, setIdObjeto] = useState("0")
    const [load, setLoad] = useState(false)
    const [editar, setEditar] = useState(false)
    const catalogoFechas = useApi(`Package/TravelDate/${cliente?.paquete?.ClavePaquete}`)
    const dispatch = useDispatch()
    const handleGuardar = () => {
        if (verificado)
            return null
        DialogMessage.fire({
            title: `Cambio de fecha`,
            text: `¿Esta seguro de cambiar la fecha de salida a ${FormatoFechaIso({ date: fecha, formato: "dd MMMM yyyy" })} para la referencia #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(cambiarFechaViajeAction({
                    IdPaquete: cliente?.paquete?.Id_Paquete,
                    IdBloqueSalida: idBloque,
                    IdObjeto: idObjeto
                })).then(Response => {
                    setLoad(false)
                    if (Response?.status && Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    setEditar(false)
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    const handleSelecFecha = (event) => {
        const valores = event.target.value.split(",")
        setValue(event.target.value)
        setFecha(valores[2])
        setIdBloque(valores[1])
        setIdObjeto(valores[0])
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    if (catalogoFechas.length > 0) return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <p>Paquete: <b>{cliente?.paquete?.Nombre}</b></p>
                    <p>Fecha de salida actual: <b>{FormatoFechaIso({ date: cliente?.paquete?.Fecha_Viaje, formato: "dd MMMM yyyy" })}</b></p>
                </Grid>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <FormControl variant="outlined" style={{ width: "100%" }}>
                            <InputLabel id="lFecha">Fecha de salida</InputLabel>
                            <Select
                                disabled={verificado || !editar || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                labelId="lFecha"
                                id="SFecha"
                                name="SFecha"
                                onChange={handleSelecFecha}
                                label="Fecha de salida"
                                value={value}
                            >
                                <MenuItem value="0,0,0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {catalogoFechas.map((item, index) => (
                                    <MenuItem key={index} value={`${item.IdObjeto},${item.IdBloqueSalida},${item.FechaSalida}`}>
                                        {`${FormatoFechaIso({ date: item.FechaSalida, formato: "dd MMMM yyyy" })} - ${item.Descripcion} - ${formatDinero(item.Precio)}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                disabled={verificado || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                onClick={hangdleClickEditar}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={fecha === "0" || verificado}
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    disabled={verificado}
                                    onClick={hangdleClickEditar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </div>
    )
    return <div>
        No hay fechas diponibles para el paquete <b>{cliente?.paquete?.Nombre}</b>
    </div>
}
export default FFechaViaje